var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBitLogoDetailed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "108.19855mm",
    height: "106.11768mm",
    viewBox: "0 0 108.19855 106.11768",
    id: "svg1",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -351.47214,
    y: -97.631157,
    width: 240.17264,
    height: 197.21494,
    id: "rect67"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-42.122443,-35.994695)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g77",
    transform: "matrix(0.54342084,0,0,0.50166944,62.181474,42.045493)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.421875,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.356559,
      strokeLinejoin: "round",
      strokeDasharray: "none"
    },
    id: "path77",
    cx: 62.597679,
    cy: 193.42424,
    rx: 99.331909,
    ry: 5.8652382
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#604d4f",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 2.43341,
      strokeDasharray: "none"
    },
    id: "rect1",
    width: 145.47925,
    height: 144.50316,
    x: -62.218708,
    y: 37.10088,
    transform: "matrix(0.85842321,-0.51294209,0.49051669,0.8714318,0,0)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-74-33-5-86",
    cx: 39.244415,
    cy: 140.03473,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-74-33-5-8",
    cx: -19.796608,
    cy: 140.01727,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9",
    cx: 72.348228,
    cy: 46.095554,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-9",
    cx: 72.375114,
    cy: 55.005451,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-7",
    cx: 64.849922,
    cy: 55.036324,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2",
    cx: 56.184471,
    cy: 55.000053,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-6",
    cx: 47.912544,
    cy: 55.068558,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-9",
    cx: 39.172119,
    cy: 55.052635,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-7",
    cx: 31.089455,
    cy: 54.977451,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-77",
    cx: 22.386353,
    cy: 55.047173,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-5",
    cx: 13.804115,
    cy: 55.020199,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-8",
    cx: 5.59935,
    cy: 55.030952,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-90",
    cx: -2.4576647,
    cy: 55.037663,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-96",
    cx: -11.285629,
    cy: 55.040462,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-1",
    cx: -19.800728,
    cy: 55.048298,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-4",
    cx: -28.776428,
    cy: 55.018745,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-0",
    cx: -37.298084,
    cy: 55.05238,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-76",
    cx: -45.877556,
    cy: 55.020172,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-962",
    cx: -54.602077,
    cy: 55.039005,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-74",
    cx: -54.575268,
    cy: 63.404942,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-74-7",
    cx: -45.904381,
    cy: 63.388752,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-74-3",
    cx: -37.335579,
    cy: 63.42498,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-74-7-1",
    cx: -28.791077,
    cy: 63.382042,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-74-33",
    cx: -19.777878,
    cy: 63.399548,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-1-7",
    cx: -19.791313,
    cy: 71.648277,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-74-33-5",
    cx: -19.722801,
    cy: 80.501823,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-1-8",
    cx: 47.920616,
    cy: 71.624489,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-74-33-9",
    cx: 47.897789,
    cy: 80.523712,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-74-33-9-5",
    cx: 47.931358,
    cy: 88.825104,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-74-7-3",
    cx: -11.262894,
    cy: 63.405045,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-74-3-8",
    cx: -2.46299,
    cy: 63.398376,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-74-7-1-6",
    cx: 5.6091919,
    cy: 63.4011,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-74-8",
    cx: 13.819405,
    cy: 63.354309,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-74-7-9",
    cx: 22.393425,
    cy: 63.386555,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-74-3-7",
    cx: 31.091385,
    cy: 63.390491,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-74-7-1-7",
    cx: 39.165863,
    cy: 63.409363,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-74-7-3-5",
    cx: -11.26899,
    cy: 71.568512,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-74-3-8-4",
    cx: -2.4690859,
    cy: 71.561844,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-74-7-1-6-05",
    cx: 5.603096,
    cy: 71.564568,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-74-8-9",
    cx: 13.813309,
    cy: 71.517776,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-74-7-9-4",
    cx: 22.387329,
    cy: 71.550018,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-74-3-7-6",
    cx: 31.085289,
    cy: 71.553955,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-74-7-1-7-9",
    cx: 39.159752,
    cy: 71.57283,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-74-7-1-7-9-2",
    cx: 39.196053,
    cy: 80.522293,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-74-33-6",
    cx: 47.956291,
    cy: 63.389038,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-74-7-3-4",
    cx: 56.229576,
    cy: 63.375618,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-74-3-8-3",
    cx: 64.583443,
    cy: 63.336662,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-74-7-1-6-0",
    cx: 72.400093,
    cy: 63.323242,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-6",
    cx: -11.314293,
    cy: 46.135067,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-1",
    cx: -2.4375002,
    cy: 46.142448,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#bf8e28",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 1.89202,
      strokeDasharray: "none"
    },
    id: "rect2",
    width: 54.798618,
    height: 63.645557,
    x: -16.339714,
    y: 78.653976,
    ry: 15.082738,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2",
    cx: -54.559868,
    cy: 46.110619,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-7",
    cx: -45.900928,
    cy: 46.110695,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-0",
    cx: -37.316494,
    cy: 46.131092,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-0-6",
    cx: -37.262852,
    cy: 80.519424,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-74-3-2",
    cx: -37.300346,
    cy: 88.892021,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-0-5",
    cx: -37.281261,
    cy: 71.598137,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-0-4",
    cx: -45.856155,
    cy: 80.571304,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-74-3-72",
    cx: -45.89365,
    cy: 88.943901,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-0-4",
    cx: -45.874565,
    cy: 71.650017,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-0-9",
    cx: -54.562954,
    cy: 80.574287,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-74-3-0",
    cx: -54.600449,
    cy: 88.946892,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-0-8",
    cx: -54.581364,
    cy: 71.653,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-8",
    cx: -28.817898,
    cy: 46.142002,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-4-1",
    cx: -28.727242,
    cy: 80.548912,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-74-7-1-0",
    cx: -28.74189,
    cy: 88.912209,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-8-8",
    cx: -28.768711,
    cy: 71.672173,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-2",
    cx: -19.802422,
    cy: 46.134727,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-4",
    cx: 5.6069794,
    cy: 46.129974,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-10",
    cx: 13.794899,
    cy: 46.149433,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-61",
    cx: 22.365456,
    cy: 46.112831,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-65",
    cx: 31.061119,
    cy: 46.136898,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-7-3",
    cx: 31.112167,
    cy: 156.26096,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-77-3",
    cx: 22.409088,
    cy: 156.33067,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-5-8",
    cx: 13.826843,
    cy: 156.30371,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-8-0",
    cx: 5.6220779,
    cy: 156.31445,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-90-4",
    cx: -2.4349368,
    cy: 156.32117,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-96-7",
    cx: -11.262901,
    cy: 156.32397,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-1-6",
    cx: -19.778,
    cy: 156.3318,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-74-33-8",
    cx: -19.75515,
    cy: 164.68306,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-1-7-9",
    cx: -19.800873,
    cy: 172.85106,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-74-7-3-0",
    cx: -11.240166,
    cy: 164.68855,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-74-3-8-6",
    cx: -2.4402621,
    cy: 164.68188,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-74-7-1-6-8",
    cx: 5.6319122,
    cy: 164.6846,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-74-8-7",
    cx: 13.842133,
    cy: 164.63782,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-74-7-9-9",
    cx: 22.416153,
    cy: 164.67006,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-74-3-7-0",
    cx: 31.114128,
    cy: 164.674,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-74-7-3-5-3",
    cx: -11.278549,
    cy: 172.85202,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-74-3-8-4-3",
    cx: -2.446358,
    cy: 172.84535,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-74-7-1-6-05-3",
    cx: 5.625824,
    cy: 172.84807,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-74-8-9-7",
    cx: 13.836044,
    cy: 172.80128,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-74-7-9-4-3",
    cx: 22.410057,
    cy: 172.83353,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-74-3-7-6-2",
    cx: 31.108017,
    cy: 172.83746,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-6-6",
    cx: -11.291565,
    cy: 147.41858,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-1-5",
    cx: -2.4147723,
    cy: 147.42595,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-2-2",
    cx: -19.779694,
    cy: 147.41823,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-4-6",
    cx: 5.6297073,
    cy: 147.41348,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-10-5",
    cx: 13.817627,
    cy: 147.43294,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-61-8",
    cx: 22.388184,
    cy: 147.39633,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-65-7",
    cx: 31.083847,
    cy: 147.42041,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-45",
    cx: 39.186737,
    cy: 46.167881,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-44",
    cx: 47.974342,
    cy: 46.186878,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-68",
    cx: 56.160316,
    cy: 46.125103,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-49",
    cx: 64.70623,
    cy: 46.10899,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-0",
    cx: 72.420753,
    cy: 71.637955,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-9-3",
    cx: 72.447639,
    cy: 80.547844,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-7-4",
    cx: 64.69413,
    cy: 80.601547,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-03",
    cx: 56.256996,
    cy: 80.54245,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-74-7-3-4-9",
    cx: 56.302101,
    cy: 88.918015,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-74-3-8-3-1",
    cx: 64.655968,
    cy: 88.879059,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-74-7-1-6-0-9",
    cx: 72.472618,
    cy: 88.865639,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-68-6",
    cx: 56.232841,
    cy: 71.667503,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-49-9",
    cx: 64.778755,
    cy: 71.65139,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-04",
    cx: 72.35096,
    cy: 97.172295,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-9-6",
    cx: 72.377846,
    cy: 106.08219,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-7-2",
    cx: 64.624336,
    cy: 106.27289,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-67",
    cx: 56.187202,
    cy: 106.0768,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-6-5",
    cx: 47.915276,
    cy: 106.1453,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-4-6",
    cx: -28.773701,
    cy: 106.09549,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-0-98",
    cx: -37.295357,
    cy: 106.12912,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-76-7",
    cx: -45.874828,
    cy: 106.09692,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-962-2",
    cx: -54.59935,
    cy: 106.11575,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-74-82",
    cx: -54.57254,
    cy: 114.48169,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-74-7-99",
    cx: -45.901653,
    cy: 114.4655,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-74-3-6",
    cx: -37.332851,
    cy: 114.50172,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-74-7-1-02",
    cx: -28.788349,
    cy: 114.45879,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-1-8-7",
    cx: 47.923347,
    cy: 122.70123,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-74-33-9-6",
    cx: 47.991859,
    cy: 131.64612,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-74-33-9-5-1",
    cx: 48.030952,
    cy: 140.03101,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-74-33-6-3",
    cx: 47.959023,
    cy: 114.46579,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-74-7-3-4-2",
    cx: 56.232307,
    cy: 114.45237,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-74-3-8-3-15",
    cx: 64.586174,
    cy: 114.4134,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-74-7-1-6-0-99",
    cx: 72.402824,
    cy: 114.39998,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-14",
    cx: -54.55714,
    cy: 97.187363,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-7-9",
    cx: -45.898201,
    cy: 97.187439,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-0-1",
    cx: -37.313766,
    cy: 97.207832,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-0-6-0",
    cx: -37.260124,
    cy: 131.59618,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-74-3-2-7",
    cx: -37.297619,
    cy: 139.96878,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-0-5-5",
    cx: -37.278534,
    cy: 122.67487,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-0-4-8",
    cx: -45.853428,
    cy: 131.64806,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-74-3-72-7",
    cx: -45.890923,
    cy: 140.02066,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-0-4-0",
    cx: -45.871838,
    cy: 122.72675,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-0-9-4",
    cx: -54.560226,
    cy: 131.65105,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-74-3-0-8",
    cx: -54.597721,
    cy: 140.02365,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-0-8-0",
    cx: -54.578636,
    cy: 122.72974,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-8-4",
    cx: -28.81517,
    cy: 97.218742,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-4-1-2",
    cx: -28.724514,
    cy: 131.62567,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-74-7-1-0-9",
    cx: -28.739162,
    cy: 139.98897,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-8-8-6",
    cx: -28.765984,
    cy: 122.74892,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-74-82-0",
    cx: -54.484615,
    cy: 147.41502,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-74-7-99-4",
    cx: -45.813728,
    cy: 147.39883,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-74-3-6-0",
    cx: -37.244926,
    cy: 147.43506,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-74-7-1-02-9",
    cx: -28.70042,
    cy: 147.39211,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-0-6-0-1",
    cx: -37.172199,
    cy: 164.5295,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-74-3-2-7-9",
    cx: -37.306561,
    cy: 172.83752,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-0-5-5-6",
    cx: -37.190609,
    cy: 155.6082,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-0-4-8-2",
    cx: -45.765503,
    cy: 164.58138,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-74-3-72-7-5",
    cx: -45.899864,
    cy: 172.84097,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-0-4-0-4",
    cx: -45.783913,
    cy: 155.66008,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-0-9-4-4",
    cx: -54.472301,
    cy: 164.58437,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-0-8-0-9",
    cx: -54.490711,
    cy: 155.66307,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-4-1-2-9",
    cx: -28.636585,
    cy: 164.55899,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-74-7-1-0-9-3",
    cx: -28.812679,
    cy: 172.87386,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-8-8-6-6",
    cx: -28.678059,
    cy: 155.68225,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-44-1",
    cx: 47.977074,
    cy: 97.263618,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-68-0",
    cx: 56.163048,
    cy: 97.201843,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-49-4",
    cx: 64.708961,
    cy: 97.18573,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-0-2",
    cx: 72.423485,
    cy: 122.7147,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-9-3-2",
    cx: 72.450371,
    cy: 131.6246,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-7-4-2",
    cx: 64.742531,
    cy: 131.65549,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-03-0",
    cx: 56.259727,
    cy: 131.61922,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-74-7-3-4-9-5",
    cx: 56.304832,
    cy: 139.99477,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-74-3-8-3-1-5",
    cx: 64.755562,
    cy: 139.9881,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-74-7-1-6-0-9-2",
    cx: 72.475349,
    cy: 140.03926,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-68-6-9",
    cx: 56.235573,
    cy: 122.74426,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-49-9-0",
    cx: 64.781487,
    cy: 122.72813,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-1-8-7-9",
    cx: 47.962914,
    cy: 155.65782,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-74-33-9-6-4",
    cx: 47.930641,
    cy: 164.6712,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-74-33-9-5-1-3",
    cx: 47.905159,
    cy: 172.82613,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-74-33-6-3-5",
    cx: 47.998589,
    cy: 147.42238,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-1-8-7-9-1",
    cx: 39.236595,
    cy: 155.68007,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-74-33-9-6-4-0",
    cx: 39.204315,
    cy: 164.64778,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-74-33-9-5-1-3-4",
    cx: 39.224503,
    cy: 172.84837,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-74-33-6-3-5-8",
    cx: 39.272263,
    cy: 147.44463,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-74-7-3-4-2-1",
    cx: 56.271873,
    cy: 147.40895,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-74-3-8-3-15-7",
    cx: 64.62574,
    cy: 147.36998,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-74-7-1-6-0-99-4",
    cx: 72.44239,
    cy: 147.35657,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-0-2-3",
    cx: 72.398476,
    cy: 155.67128,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-9-3-2-1",
    cx: 72.425362,
    cy: 164.67805,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-7-4-2-4",
    cx: 64.782097,
    cy: 164.61206,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-03-0-6",
    cx: 56.202431,
    cy: 164.60808,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-74-7-3-4-9-5-9",
    cx: 56.182945,
    cy: 172.82219,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-74-3-8-3-1-5-4",
    cx: 64.76284,
    cy: 172.84781,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-9-2-74-7-1-6-0-9-2-2",
    cx: 72.385765,
    cy: 172.73752,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-68-6-9-2",
    cx: 56.275139,
    cy: 155.70084,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.397,
      strokeDasharray: "none"
    },
    id: "path2-49-9-0-6",
    cx: 64.788765,
    cy: 155.717,
    rx: 3.1354928,
    ry: 2.9940414,
    transform: "rotate(-30.111766)"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(0.22887739,-0.13273838,0.13273838,0.22887739,127.68667,60.653723)",
    id: "text67",
    style: {
      fontSize: 128,
      textAlign: "start",
      writingMode: "lr-tb",
      direction: "ltr",
      whiteSpace: "pre",
      shapeInside: "url(#rect67)",
      display: "inline",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "#050a13"
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -351.47266,
    y: 19.745141,
    id: "tspan2"
  }, /*#__PURE__*/React.createElement("tspan", {
    style: {
      fontFamily: "'DejaVu Math TeX Gyre'",
      InkscapeFontSpecification: "'DejaVu Math TeX Gyre'"
    },
    id: "tspan1"
  }, "bit"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitLogoDetailed);
export default __webpack_public_path__ + "static/media/bitLogoDetailed.d550d17450b6885a6ae06ba4fd156138.svg";
export { ForwardRef as ReactComponent };